import { createAsyncThunk } from '@reduxjs/toolkit'
import { pixiResetRoulette, pixiStartRoulette, pixiStopRoulette } from '../GameTheme/RouletteGame/pixi-scripts/bridge'
import { getMyBetsRouletteService, placeBetRouletteGameService } from '../services/rouletteGame.service'
import { generateClientSeed } from 'utils/common-functions/index'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { openSuccessToaster } from 'utils/common-services/toaster.service'
import { BET_RESULT } from 'utils/constants/index'
import { enqueueCreditWalletWaitQueue, debitBalance } from 'redux-store/redux/slices/auth.slice'

export const placedBetRouletteGame = createAsyncThunk('roulette-game/place-bet',
  async ({ payload, onSuccess }, thunkApi) => {
    try {
      pixiStartRoulette()
      openSuccessToaster({ message: 'Bet Placed Successfully' })
      const res = await placeBetRouletteGameService(payload)
      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        onSuccess()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      if (res?.betAmount) {
        thunkApi.dispatch(debitBalance(Number(res?.betAmount)))
      }
      if (res?.result === BET_RESULT.WON) {
        thunkApi.dispatch(enqueueCreditWalletWaitQueue(res?.winningAmount))
      }
      if (res?.winningNumber !== undefined) {
        pixiStopRoulette(res.winningNumber)
      } else {
        pixiResetRoulette()
      }
      return res
    } catch (error) {
      pixiResetRoulette()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsRoulette = createAsyncThunk('roulette-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsRouletteService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
